
import styled from 'styled-components';
import NavItem from '../../../bootstrap/NavItem';
import Ul from '../../../bootstrap/Ul';

export const Facilities = styled.div`
  padding-bottom: 8px;
  font-size: 13px;

  @media (max-width: 768px) {
    padding: 0;
    margin-top: 8px;
  }
`;

export const FacilitiesHeader = styled.div`
  font-size: 14px;
  margin: 0;
  padding: 8px 0 6px;
  font-weight: 500;
  color: #172839;
`;

export const FacilitiesUl = styled(Ul)`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: center;
  justify-content: start;
  column-gap: 12px;
  row-gap: 6px;
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const SingleFacilities = styled(NavItem)`
  margin: 0;
  padding: 2px 0;
  display: flex;
  align-items: center;
  min-width: 0;
`;

export const FacilitiesText = styled.p`
  font-size: 13px;
  line-height: 1.3;
  margin: 0;
`;

export const CheckboxIcon = styled.img`
  width: 16px;
  height: 16px;
  display: block;
  flex-shrink: 0;
  margin-right: 7px;
`;
